var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.card_error)?_c('b-alert',{staticClass:"p-2",staticStyle:{"font-size":"0.7rem"},attrs:{"variant":"danger","show":""}},[_vm._v(_vm._s(_vm.card_error))]):_vm._e(),_c('div',{ref:"card"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }